import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoOutlined from '@material-ui/icons/InfoOutlined';

const GUIDE_ROWS = [
    { id: 'heading', syntax: '# / ## / ###', resultKey: 'MD-GUIDE-ROW-HEADING-RESULT', exampleKey: 'MD-GUIDE-ROW-HEADING-EXAMPLE' },
    { id: 'bold', syntax: '**text** / __text__', resultKey: 'MD-GUIDE-ROW-BOLD-RESULT', exampleKey: 'MD-GUIDE-ROW-BOLD-EXAMPLE' },
    { id: 'italic', syntax: '*text* / _text_', resultKey: 'MD-GUIDE-ROW-ITALIC-RESULT', exampleKey: 'MD-GUIDE-ROW-ITALIC-EXAMPLE' },
    { id: 'inline-code', syntax: '`code`', resultKey: 'MD-GUIDE-ROW-INLINE-CODE-RESULT', exampleKey: 'MD-GUIDE-ROW-INLINE-CODE-EXAMPLE' },
    { id: 'link', syntax: '[text](url)', resultKey: 'MD-GUIDE-ROW-LINK-RESULT', exampleKey: 'MD-GUIDE-ROW-LINK-EXAMPLE' },
    { id: 'list', syntax: '- item', resultKey: 'MD-GUIDE-ROW-LIST-RESULT', exampleKey: 'MD-GUIDE-ROW-LIST-EXAMPLE' },
    { id: 'code-block', syntax: '``` … ```', resultKey: 'MD-GUIDE-ROW-CODE-BLOCK-RESULT', exampleKey: 'MD-GUIDE-ROW-CODE-BLOCK-EXAMPLE' }
];

function MarkdownGuide() {
    const label = 'CONTENT.GLOBAL-ANNOUNCEMENT.';
    const { t } = useTranslation();

    return (
        <div className="ga-md-guide">
            <div className="ga-md-guide-header">
                <div className="ga-md-guide-icon">
                    <InfoOutlined fontSize="small" />
                </div>
                <div>
                    <h3>{t(label + 'MD-GUIDE-TITLE')}</h3>
                    <p>{t(label + 'MD-GUIDE-DESCRIPTION')}</p>
                </div>
            </div>

            <div className="ga-md-guide-table-wrap">
                <table className="ga-md-guide-table">
                    <thead>
                        <tr>
                            <th>{t(label + 'MD-GUIDE-COL-SYNTAX')}</th>
                            <th>{t(label + 'MD-GUIDE-COL-RESULT')}</th>
                            <th>{t(label + 'MD-GUIDE-COL-EXAMPLE')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {GUIDE_ROWS.map(row => (
                            <tr key={row.id}>
                                <td><code className="ga-md-syntax">{row.syntax}</code></td>
                                <td>{t(label + row.resultKey)}</td>
                                <td><code className="ga-md-example">{t(label + row.exampleKey)}</code></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <p className="ga-md-guide-footnote">{t(label + 'MD-GUIDE-FOOTNOTE')}</p>
        </div>
    );
}

export default MarkdownGuide;
